import React from 'react';

import Box from '@material-ui/core/Box';
import CircularProgress from '@material-ui/core/CircularProgress';
import NoSsr from '@material-ui/core/NoSsr';

const Loader = ({ showBackDrop = false, position = 'fixed' }) => {
	const [open, setOpen] = React.useState(false);
	React.useEffect(() => {
		setOpen(true);
	}, []);
	if (!open) return <></>;

	setTimeout(() => {
		setOpen(false);
	}, 30000);
	return (
		<NoSsr>
			<div
				style={{ zIndex: 9998, display: showBackDrop ? 'block' : 'none' }}
				className={`${position} inset-0 bg-gray-600 bg-opacity-50 overflow-y-auto h-full w-full ease-in`}
			></div>
			<Box
				zIndex={9999}
				height="100%"
				display="flex"
				flex={1}
				alignItems="center"
				justifyContent="center"
				position="absolute"
				top={0}
				left={0}
				right={0}
				bottom={0}
			>
				<CircularProgress />
			</Box>
		</NoSsr>
	);
};

export default Loader;
